import { HorizontalSectionInfo } from '../../core/types/ui/placement';
import { IPosition2d } from '../../core/types/ui/position';
import { Size } from '../../core/types/ui/size';

export enum WindowType {
  Group = 'G',
  App = 'S',
}

export enum ApplicationType {
  Sheet = 'Sheet',
  Drive = 'Drive',
}
export interface SheetWindowApp {
  appType: ApplicationType.Sheet;
  groupId: string;
  sheetId: string;
}

export interface DriveWindowApp {
  appType: ApplicationType.Drive;
}

export type WindowMetaData = SheetWindowApp | DriveWindowApp;

// export interface WindowMetaData {
//   // windowType: WindowType;
//   groupId?: string;
//   // appId: string;
//   sheetId: string
//   appType: ApplicationType;
// }

interface WindowTopSection {
  // controlBar: HorizontalSectionInfo;
}

interface WindowBottomSection {
  statusBar: HorizontalSectionInfo;
}

export type WindowGeometry = IPosition2d & Size;

export interface AppWindow extends WindowGeometry {
  id: string;
  // topSection: WindowTopSection;
  // bottomSection: WindowBottomSection;

  isMinimized: boolean;
  isMaximized: boolean;

  createdDate: string;

  metaData: WindowMetaData;
}
